module.exports = __webpack_public_path__ + "tj.svg?62c80f50ba21c0e1e3194e8e64f7f7eb";